/**
 * APIのURL
 */
export const API_URL = process.env.REACT_APP_API_URL as string;

/**
 * APIキー
 */
export const API_KEY = process.env.REACT_APP_API_KEY as string;

/**
 * 環境情報
 */
export const ENV_INFO = process.env.REACT_APP_ENV_INFO as string;

/**
 * 建物ID
 */
export const BUILDING_ID = process.env.REACT_APP_ENV_BUILDING_ID as unknown as number;

